// extracted by mini-css-extract-plugin
export default {"hero":"product_hero__D8xHG","services":"product_services__nBGgW"};